import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ConnectionProvider } from "~lib/ConnectionProvider";
import { ToastContainer, Zoom } from "react-toastify";
import "@fontsource/dejavu-sans/400.css";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <>
    <ConnectionProvider>
      <App />
    </ConnectionProvider>
    <ToastContainer
      position="top-left"
      pauseOnHover={false}
      autoClose={2500}
      theme="dark"
      transition={Zoom}
      limit={3}
    />
  </>
);
